import { render, staticRenderFns } from "./blackPhone.vue?vue&type=template&id=4beaa106&scoped=true"
import script from "./blackPhone.vue?vue&type=script&lang=js"
export * from "./blackPhone.vue?vue&type=script&lang=js"
import style0 from "./blackPhone.vue?vue&type=style&index=0&id=4beaa106&prod&lang=less"
import style1 from "./blackPhone.vue?vue&type=style&index=1&id=4beaa106&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beaa106",
  null
  
)

export default component.exports